var render = function render(){var _vm=this,_c=_vm._self._c;return _c('toggle-button',{staticClass:"mr-2",attrs:{"value":_vm.toggle ? true : false,"labels":_vm.labels,"width":120},on:{"change":function($event){return _vm.publishProfile($event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }